export enum EFormName {
  ADD_EDIT_CONTACT = 'ADD_EDIT_CONTACT',
  NEW_WISH_LIST = 'NEW_WISH_LIST',
  SHARE_WISH = 'SHARE_WISH',
  WISH_LIST_AUTH = 'WISH_LIST_AUTH',
  WIZARD = 'WIZARD',
  CLOSE_GROUP_MONEYBOX = 'CLOSE_GROUP_MONEYBOX',
  CLOSE_GROUP_WISH = 'CLOSE_GROUP_WISH',
  INVITE_CONTACT = 'INVITE_CONTACT',
  NEW_WISH = 'NEW_WISH',
  NEW_WISH_GROUP = 'NEW_WISH_GROUP',
  POLICY = 'POLICY',
  THIRD_PARTY_PAYMENT_FORM = 'THIRD_PARTY_PAYMENT_FORM',
  WISH_FINDER = 'WISH_FINDER',
}

export type TFormName =
  | EFormName.ADD_EDIT_CONTACT
  | EFormName.NEW_WISH_LIST
  | EFormName.SHARE_WISH
  | EFormName.WISH_LIST_AUTH
  | EFormName.WIZARD
  | EFormName.CLOSE_GROUP_MONEYBOX
  | EFormName.CLOSE_GROUP_WISH
  | EFormName.INVITE_CONTACT
  | EFormName.NEW_WISH
  | EFormName.NEW_WISH_GROUP
  | EFormName.POLICY
  | EFormName.THIRD_PARTY_PAYMENT_FORM;
